module.exports = __webpack_public_path__ + "img/link.4aa548f2.svg";